import React from "react";
import styled from "styled-components";

interface Props {
  action?: React.ReactNode;
  button?: React.ReactNode;
}

const SectionRow = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SectionRowAction = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);

  .MuiTypography-root {
    padding-right: 12px;
  }
`;

const SectionRowButton = styled.div`
  position: absolute;
  top: 100%;
  margin-top: 14px;
  right: 0;
  transform: translateY(-50%);
  cursor: pointer;

  .MuiTypography-root {
    padding-right: 12px;
  }
`;

export const ProfileSectionRow: React.FC<Props> = (props) => {
  return (
    <SectionRow style={{ marginBottom: props.button && "34px" }}>
      {props.children}

      {props.action && <SectionRowAction>{props.action}</SectionRowAction>}
      {props.button && <SectionRowButton>{props.button}</SectionRowButton>}
    </SectionRow>
  );
};
